import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFileUploadComponent } from './componentes/custom-file-upload/custom-file-upload.component';
import { CustomImagePreviewComponent } from './componentes/custom-image-preview/custom-image-preview.component';
import { CustomTableComponent } from './componentes/custom-table/custom-table.component';
import { CustomXmlViewerComponent } from './componentes/custom-xml-viewer/custom-xml-viewer.component';
import { CuentasContablesSeleccionComponent } from './componentes/cuentas-contables-seleccion/cuentas-contables-seleccion.component';
import { CustomLoadingSpinnerComponent } from './componentes/custom-loading-spinner/custom-loading-spinner.component';
import { CustomSelectComponent } from './componentes/custom-select/custom-select.component';
import { ImportsModule } from '../importsmodule/imports';
import { NumberFormatDirective } from './librerias/numberFormat.directive';


@NgModule({
  declarations: [
    CustomFileUploadComponent,
    CustomImagePreviewComponent,
    CustomTableComponent,
    CustomXmlViewerComponent,
    CuentasContablesSeleccionComponent,
    CustomLoadingSpinnerComponent,
    CustomSelectComponent,
    NumberFormatDirective
  ],
  imports: [
    CommonModule,
    ImportsModule
  ],
  exports: [
    CustomFileUploadComponent,
    CustomImagePreviewComponent,
    CustomTableComponent,
    CustomXmlViewerComponent,
    CuentasContablesSeleccionComponent,
    CustomLoadingSpinnerComponent,
    CustomSelectComponent,
    NumberFormatDirective]
})
export class ComponentesComunesModule { }
